module.exports = __webpack_public_path__ + "static/how-to-live-bcdf20311954f4e1342e658cdd5b8e25.jpg";